export const clearSessionStorageByKey = (keyToClear: string) => {
  if (!keyToClear) return;

  const keysToRemove = Object.keys(window.sessionStorage).filter((key) =>
    key.includes(keyToClear)
  );

  for (const key of keysToRemove) {
    window.sessionStorage.removeItem(key);
  }
};
